import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './en-translation.json';
import translationRU from './ru-translation.json';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LS_SELECTED_LANGUAGE } from '@shared/constants/storagesKeysConstants';
import { AppLanguage } from '@shared/types';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: AppLanguage.ENG,
        debug: true,
        lng: localStorage.getItem(LS_SELECTED_LANGUAGE),
        resources: {
            en: {
                translation: translationEN,
            },
            ru: {
                translation: translationRU,
            },
        },
    });

export default i18n;
